export default "__VITE_ASSET__D6Kuqd4n__"